import { useTranslation } from "react-i18next";
import { usePfTranslate } from "../../hooks/useTranslationEx";
import { AppInfo } from "../../utils/app-info";
import { getPf } from "../../utils/conf";
import { icAsset } from "../image/image-src";

const Footer = () => {
  const { t } = useTranslation();
  const { pfTl } = usePfTranslate();
  return (
    <footer className="ui-footer flex flex-col bg-gray-50 pb-20 sm:h-[23.5rem] sm:pb-0">
      <div className="mb-[1rem] flex w-full flex-col items-center gap-[2.5rem]">
        <div className="flex w-full flex-col justify-center bg-gray-50 px-4 pt-10 sm:pt-0 md:flex-row">
          <div className="mx-auto flex w-full max-w-[1160px] flex-wrap gap-[34px] sm:mt-[4.625rem] md:flex-nowrap md:justify-between">
            {/* Address Section */}
            <div className="flex w-full flex-col items-start gap-[20px] md:w-fit">
              <h6 className="text-[16px] font-semibold text-gray-900">
                {t("Address")}
              </h6>

              <div className="flex flex-col gap-[5px]">
                {/* addition */}
                {/* <TtRow title={t("Biz Reg")} content={t("656-86-03425")} />
                <TtRow title={t("Corp. Name")} content={t("TAMIS Co Ltd")} />
                <TtRow
                  title={t("Representative Name")}
                  content={t("Yoo Kyunghee")}
                />
                <TtRow
                  title={t("E-commerce No")}
                  content={t("2024-Seoul Mapo-2440")}
                /> */}

                <TtRow
                  title={t("Headquarters")}
                  content={t("footer-address-new-york")}
                />
                <TtRow
                  title={t("Korea Branch")}
                  content={t("footer-address-korean")}
                />
                <TtRow
                  title={t("Operating hours")}
                  content={t("footer-operating-hours")}
                />
              </div>
            </div>

            {/* Contact Section */}
            <div className="flex w-full flex-col items-start gap-[22px] md:w-fit">
              <h6 className="text-[16px] font-semibold text-gray-900">
                {t("Contact")}
              </h6>
              <div className="flex flex-col gap-[5px]">
                <TtRow
                  title={t("Phone Number")}
                  content={AppInfo.get("phone")}
                />
                <TtRow
                  title={t("Customer Service")}
                  content={AppInfo.get("email")}
                />
                <TtRow
                  title={t("Partnership")}
                  content={AppInfo.get("partnership")}
                />
              </div>
            </div>

            {/* Terms and Policy Section */}
            <div className="flex w-full flex-col items-start gap-[1.25rem] md:w-fit">
              <h6 className="text-[16px] font-semibold text-gray-900">
                {t("Term and Policy")}
              </h6>
              <ul className="flex flex-col gap-[5px]">
                {[
                  [
                    t("Travel Terms and Conditions"),
                    "travelTermsAndConditions",
                  ],
                  [t("Term of Use"), "termOfUse"],
                  [t("Privacy Policy"), "privacyPolicy"],
                  [t("Cancel and Refund Policy"), "cancelAndRefundPolicy"],
                ].map((item, index) => (
                  <li className="leading-[20px]" key={index}>
                    <a
                      href={"/p/termPolicy/" + item[1]}
                      className="text-[13px] leading-[20px] text-gray-600"
                    >
                      {item[0]}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Social Section */}
            <div className="flex w-full flex-col items-start gap-[1.25rem] md:w-fit">
              <h6 className="text-[16px] font-semibold text-gray-900">
                {t("Social")}
              </h6>
              <div className="flex gap-[12px]">
                {[
                  {
                    href: "https://blog.naver.com/tamice",
                    icon: "nv.svg",
                    alt: "Naver Icon",
                  },
                  {
                    href: AppInfo.get("kakao"),
                    icon: "kk.svg",
                    alt: "KakaoTalk Icon",
                  },
                  {
                    href: "https://www.instagram.com/with.tamice/",
                    icon: "ig.svg",
                    alt: "Instagram Icon",
                  },
                ]
                  .filter((x) => x.href)
                  .map(({ href, icon, alt }, idx) => (
                    <a
                      key={href}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition-transform duration-200 hover:scale-110"
                    >
                      <img
                        className="h-[2.5rem]"
                        src={icAsset(`../../assets/icons/${icon}`)}
                        alt={alt}
                        loading="lazy"
                      />
                    </a>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mx-auto w-full max-w-[1160px]">
          <div className="flex flex-col gap-[1.5rem]">
            <div className="h-[0.0625rem] bg-gray-300"></div>
            <div className="flex flex-col items-center justify-between gap-[1.25rem] md:flex-row">
              <p className="text-sm font-normal leading-[22px] text-[#727272]">
                {getPf() === "TRAVITY"
                  ? t("copyright-text-travity")
                  : t("copyright-text-tamice")}
              </p>
              <div className="flex flex-wrap gap-3 px-2 sm:px-0">
                {[
                  "visa.svg",
                  "mastercard.svg",
                  "discover.svg",
                  "paypal.svg",
                  "jcb.svg",
                  "amex.svg",
                ].map((icon, index) => (
                  <img
                    key={index}
                    className="h-[2.5rem] cursor-pointer"
                    src={icAsset(`../../assets/icons/${icon}`)}
                    alt={`${icon.split(".")[0]} Icon`}
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

const TtRow = ({ title, content }: { title: string; content: string }) => {
  if (!content) return null; // If content is empty, do not render the row
  return (
    <p className="text-[13px] leading-[20px] text-gray-600">
      <span className="font-semibold">{title} </span>
      {content}
    </p>
  );
};
